module.exports = __webpack_public_path__ + "img/4.d5201b43.jpg";